import { Blockquote, Button } from '@ui';
import { useTranslation } from 'react-i18next';

export type LedgerDecision = 'book' | 'skip';

interface Props {
    onDecide: (decision: LedgerDecision) => void;
}

/** Asks whether a document dated before the accounting start goes into the books. Not booking is the default. */
const LedgerDecisionDialog = ({ onDecide }: Props) => {
    const { t } = useTranslation('invoice');

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <p className="tw-mb-0">{t('ledgerDecision.text')}</p>
            <Blockquote size="sm" className="!tw-my-0">
                {t('ledgerDecision.hint')}
            </Blockquote>
            <div className="tw-flex tw-flex-wrap tw-justify-end tw-gap-2">
                <Button size="sm" flat color="light" onPress={() => onDecide('book')}>
                    {t('ledgerDecision.book')}
                </Button>
                <Button size="sm" color="primary" onPress={() => onDecide('skip')}>
                    {t('ledgerDecision.skip')}
                </Button>
            </div>
        </div>
    );
};

export default LedgerDecisionDialog;
